module.exports = __webpack_public_path__ + "images/flags-f425a1064912bb9c1ef8da90c002860a.png";